import { useContext } from "react";

import { Switch } from "@/components/shadcn/switch";
import { BetaFieldContext } from "@/components/Form/NoxusFormLabel";
import { ReleaseStatusBadge } from "@/components/UI/ReleaseStatusBadge";

export const ToolSectionHeader = ({
  icon,
  iconBg,
  iconColor,
  title,
  titleSuffix,
  subtitle,
  enabled,
  onToggle,
  isDisabled,
}: {
  icon?: React.ReactNode;
  iconBg?: string;
  iconColor?: string;
  title: string;
  titleSuffix?: React.ReactNode;
  subtitle: string;
  enabled?: boolean;
  onToggle?: (checked: boolean) => void;
  isDisabled?: boolean;
}) => {
  // An explicit titleSuffix wins; otherwise badge it if the field is gated.
  const isBeta = useContext(BetaFieldContext);

  return (
    <div className="flex items-center justify-between">
      <div className="flex items-center gap-2">
        {icon && (
          <div
            className="flex p-2 rounded-lg justify-center items-center"
            style={{ backgroundColor: iconBg, color: iconColor }}
          >
            {icon}
          </div>
        )}
        <div>
          <div className="flex items-center gap-1.5">
            <p className="text-sm font-medium leading-none">{title}</p>
            {titleSuffix ?? (isBeta && <ReleaseStatusBadge status="beta" />)}
          </div>
          <p className="text-xs text-muted-foreground mt-1">{subtitle}</p>
        </div>
      </div>
      {onToggle && (
        <Switch
          checked={enabled}
          onCheckedChange={onToggle}
          disabled={isDisabled}
        />
      )}
    </div>
  );
};
